import React from 'react';
import { useHistory } from 'react-router-dom';
import AnchorButton from './AnchorButton';

/**
 * @typedef {object} LinkButtonProps
 * @property {string} [to] typically should be provided, but you are permitted to replace this with onClick
 * @property {boolean} [blank=false]
 * @property {object} [state]
 * @property {boolean} [keepSearch=false]
 * @property {() => void} [onClick] overrides standard href behavior. This should still perform page navigation for the HTML to be semantically correct!
 * @property {React.ReactNode} children
 * @property {boolean} [small=false]
 * @property {boolean} [minimal=false]
 * @property {boolean} [disabled=false]
 * @property {boolean} [fill=false]
 * @property {string} [text]
 * @property {string} [target]
 * @property {import('react').ReactNode | string} [icon]
 * @property {number} [iconSize]
 * @property {string} [intent]
 */

/**
 * @param {LinkButtonProps} props
 * @returns {JSX.Element}
 */
function LinkButton({ to, blank, state, match, keepSearch, onClick, ...rest }) {
  const history = useHistory();
  const { location } = history;

  const buttonProps = {};
  if (to && !onClick) {
    buttonProps.href = to;
  }

  if (!onClick) {
    onClick = (e) => {
      if (history?.location?.search && keepSearch) {
        to += history.location.search;
      }

      if (e.button === 0 && !(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) && !rest.target) {
        e.preventDefault();

        if (blank) {
          const url = (to || '').startsWith('http') ? to : `${window.location.origin}${to}`;
          window.open(url, '_blank');
        } else {
          history.push(to, Object.assign(state ?? {}, { from: location?.pathname ?? '' }));
        }
      }
    };
  }

  return <AnchorButton {...buttonProps} onClick={onClick} {...rest} />;
}

export default LinkButton;
